import {
  Component,
  OnInit,
  Inject,
  HostListener,
  ElementRef,
} from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { NavService } from "../../services/nav.service";
import { LayoutService } from "../../services/layout.service";
import SwiperCore, { Navigation, Pagination, Autoplay } from "swiper";
import { CustomerProfileService } from "../../services/customer-profile.service";
import { MessageService } from "primeng/api";
import { CommonService } from "../../services/common.service";
import { PermissionService } from "../../services/permission-service.service";

SwiperCore.use([Navigation, Pagination, Autoplay]);
@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
  providers: [MessageService],
})
export class HeaderComponent implements OnInit {
  public elem: any;
  public customizer: string = "";
  toggleUserProfile: boolean = false;
  isMobileView: boolean;
  isSearchActive: boolean;
  isDarkMode: boolean = false;
  carauselMsgList: any;
  searchPermission: any;
  currentIndex = 0;
  refreshLogin: any;
  showVisitors: boolean = false;
  headerItemsPermission: any;
  permissionMap: any;
  constructor(
    public layout: LayoutService,
    public navServices: NavService,
    @Inject(DOCUMENT) private document: any,
    public customerProfileService: CustomerProfileService,
    public messageService: MessageService,
    private commonService: CommonService,
    private elementRef: ElementRef,
    private permissionService: PermissionService
  ) {}

  ngOnInit() {
    this.refreshLogin = localStorage.getItem("refreshCounter");
    this.elem = document.documentElement;
    this.openSearch();
    this.checkMobileView();
    this.getAllCaraselmsgList();

        setTimeout(() => {
      this.permissionService
        .getResourceCategoryById("MENUS")
        .then((res: any) => {
          if (res) {
   this.searchPermission =
              res?.resource_types[1]?.resources[0]?.resource_permission[0]
                ?.CanView;
            this.headerItemsPermission = res?.resource_types[1].resources;
            console.log("header permission items",this.searchPermission)
          }
        });
    }, 2000);
  }

  
  canViewByName(name: string): boolean {
    const item = this.headerItemsPermission?.find((p) => p.Name === name);
    if (
      !item ||
      !item.resource_permission ||
      item.resource_permission.length === 0
    ) {
      return false;
    }
    return item.resource_permission[0].CanView === 1;
  }

  toggleVisitors() {
    this.showVisitors = !this.showVisitors;
  }
  @HostListener("document:click", ["$event"])
  handleClickOutside(event: Event) {
    // Close if the click is outside `app-visitors` and `app-feather-icons`
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.showVisitors = false;
    }
  }
  openSearch() {
    this.commonService.searchQuery.subscribe((query) => {
      if (query) {
        this.searchToggle();
      } else {
        this.navServices.search = false;
        setTimeout(() => {
          document.getElementById("searchbar").blur();
        });
      }
    });
  }
  @HostListener("window:resize", ["$event"])
  onResize() {
    this.checkMobileView();
  }

  checkMobileView() {
    this.isMobileView = window.innerWidth <= 768; // Adjust the value based on your breakpoint
  }

  // Toggle search view
  toggleSearch() {
    this.isSearchActive = !this.isSearchActive;
  }

  sidebarToggle() {
    this.navServices.collapseSidebar = !this.navServices.collapseSidebar;
    this.navServices.megaMenu = false;
    this.navServices.levelMenu = false;
  }

  layoutToggle() {
    this.isDarkMode = !this.isDarkMode;
    if ((this.layout.config.settings.layout_version = "dark-only")) {
      document.body.classList.toggle("dark-only");
    }
    document.body.remove;
  }

  searchToggle() {
    this.navServices.search = true;
    // document.getElementById('searchbar').focus()
  }

  languageToggle() {
    this.navServices.language = !this.navServices.language;
  }

  showCompanyChangeToggle() {
    this.navServices.changeCompany = !this.navServices.changeCompany;
  }

  toggleFullScreen() {
    this.navServices.fullScreen = !this.navServices.fullScreen;
    if (this.navServices.fullScreen) {
      if (this.elem.requestFullscreen) {
        this.elem.requestFullscreen();
      } else if (this.elem.mozRequestFullScreen) {
        /* Firefox */
        this.elem.mozRequestFullScreen();
      } else if (this.elem.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.elem.webkitRequestFullscreen();
      } else if (this.elem.msRequestFullscreen) {
        /* IE/Edge */
        this.elem.msRequestFullscreen();
      }
    } else {
      if (!this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }
  }

  Customizer(val) {
    this.customizer = val;
  }

  toggleCustomerProfile() {
    this.toggleUserProfile = !this.toggleUserProfile;
    this.customerProfileService.setProfileQuicklink(this.toggleUserProfile);
  }
  closeSearch() {
    this.isSearchActive = false;
  }

  getAllCaraselmsgList() {
    this.customerProfileService.getCarouselUpdates().then((res: any) => {
      this.carauselMsgList = res?.data;
      console.log("carasel msg ", this.carauselMsgList);
      this.startCarousel();
    });
  }
  startCarousel() {
    if (this.carauselMsgList.length > 0) {
      setInterval(() => {
        this.currentIndex =
          (this.currentIndex + 1) % this.carauselMsgList.length;
      }, 9000); // Change message every 5 seconds
    }
  }
}
